import { Component, OnInit, EventEmitter, Output, Input, OnChanges } from '@angular/core';
import { Onboarding, Status, LeadSource } from '../../../models/onboarding';
import { ApiService } from '../../../services/api.service';

@Component({
  selector: 'alg-feedback',
  templateUrl: './alg-feedback.component.html',
  styleUrls: ['./alg-feedback.component.scss']
})
export class AlgFeedbackComponent {
  @Input() items: any[];
  @Input() selectedItem: any;
  @Output() isModalOpen = new EventEmitter;
  @Output() valueSelected = new EventEmitter;

  public isBoxOpen: boolean;
  public openModal: boolean;

  constructor(private api: ApiService) { }

  openBox() {
    this.isBoxOpen = !this.isBoxOpen;
  }

  onChangeFaceValue(value) {
    // NOTE: Consider to make it fully controlled by removing next line
    this.selectedItem = value;
    this.valueSelected.emit(value);
  }

  openConditionModal() {
    this.isModalOpen.emit('open');
  }

}



// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-feedback/alg-feedback.component.ts